import * as React from 'react';
import { BaseControlColor } from '@/shared/modules/styled-system';
import * as Styled from './button.styled';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  icon?: React.FC<React.PropsWithChildren> | null;
  color?: Styled.ButtonElementProps['$color'];
  size?: Styled.ButtonElementProps['$size'];
  variant?: Styled.ButtonElementProps['$variant'];
  textColor?: Styled.ButtonElementProps['$textColor'];
  shadow?: boolean;
  fluid?: boolean;
  className?: string;
}
export const Button = React.memo(function Button({
  icon: Icon = null,
  color = BaseControlColor.SystemRegular,
  size,
  variant,
  textColor,
  shadow,
  fluid,
  className,
  children,
  ...props
}: React.PropsWithChildren<ButtonProps>) {
  return <Styled.ButtonElement {...props} $hasText={!!children} $hasIcon={!!Icon} $color={color} $size={size} $variant={variant} $textColor={textColor} $shadow={shadow} $fluid={fluid} className={className}>
      {Icon && <Styled.IconContent>
          <Icon />
        </Styled.IconContent>}
      {children && <Styled.TextContent>{children}</Styled.TextContent>}
    </Styled.ButtonElement>;
});